module.exports = __webpack_public_path__ + "fee2051bfe7a4082ee62282641d7e27d.svg";